module.exports = __webpack_public_path__ + "static/playstore-ce4d89931f74cfc1fd81fdd865c76feb.png";